import React, { useState, useEffect, useContext } from "react";
import profile from "../img/undraw_profile.svg";
import sendBtn from "../img/send-btn.png";
import { useLocation, useNavigate } from "react-router-dom";
import Pusher from "pusher-js";
import axiosHttp from "../config/axios.interceptor";
import { chatConfig, errorResponseMessage } from "../shared/const.prop";
import moment from "moment";
import { AppContext } from "../contexts/AppContext";
import Loader from "../components/Loader";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { useDispatch } from "react-redux";
import { AuthContext } from "../contexts/AuthContext";

const Chat = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { roomId, userId, pic, userName, startDate, endDate, name } =
    location.state;
  const [chats, setChats] = useState([]);
  const [msg, setMsg] = useState();
  const [message, setMessage] = useState("");
  const currentDate = new Date();
  const [loading, setLoading] = useState(true);
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();

  useEffect(() => {
    const pusher = new Pusher(chatConfig.apiKey, {
      cluster: chatConfig.cluster,
      encrypted: true,
    });
    const channel = pusher.subscribe(roomId);
    channel.bind("my-event", (data) => {
      console.log("chat-data", data);
      setMsg(data);
    });
    return () => {
      pusher.unsubscribe(roomId);
    };
  }, []);

  useEffect(() => {
    if (msg) setChats([...chats, msg]);
  }, [msg]);

  useEffect(() => {
    fetchChatData();
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  const fetchChatData = async () => {
    try {
      const getChat = await axiosHttp.get(`channel/${roomId}/messages`);
      if (getChat.status === 200) {
        let chatData = getChat.data.data;
        setChats(chatData);
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const setToMidnight = (date) => {
      const newDate = new Date(date);
      newDate.setHours(0, 0, 0, 0);
      return newDate;
    };

    const currentDateMidnight = setToMidnight(currentDate);
    const startDateMidnight = setToMidnight(startDate);
    const endDateMidnight = setToMidnight(endDate);

    const isWithinRange = (start, end) => {
      if (currentDateMidnight >= start && currentDateMidnight <= end) {
        return true;
      }
      appContext.updateNotificationState({
        type: "error",
        message: "Your session period is expired",
      });
      navigate("/myspace/queries");
    };

    isWithinRange(startDateMidnight, endDateMidnight);
  }, [currentDate, startDate, endDate, appContext, navigate]);

  const formatTime = (time) => {
    return moment.utc(time).format("h:mm A");
  };

  const formatOldTime = (time) => {
    return moment(time).format("h:mm A");
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    try {
      const postMessage = await axiosHttp.post(`pusher-event`, {
        message: message,
        channel: roomId,
        user_id: userId,
      });
      setMessage("");
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="card card-one-1 mb-5">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center w-100 flex-direction-column-mob">
          <div className="d-flex justify-content-start align-items-center">
            <div
              className="cursor-pointer"
              onClick={() => navigate("/myspace/queries")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M16.6667 10.2285C16.6667 10.5449 16.4316 10.8064 16.1266 10.8478L16.0417 10.8535L5.05508 10.853L9.02424 14.8059C9.26884 15.0495 9.26969 15.4452 9.02614 15.6898C8.80473 15.9122 8.45755 15.9331 8.21249 15.7521L8.14226 15.6917L3.10059 10.6717C3.06835 10.6396 3.04035 10.6049 3.01658 10.5682C3.00986 10.5571 3.00303 10.5458 2.99655 10.5343C2.99059 10.5244 2.98521 10.5142 2.98013 10.5038C2.97307 10.4887 2.96618 10.4731 2.95992 10.4572C2.95483 10.445 2.95059 10.433 2.94671 10.421C2.94211 10.4061 2.93764 10.3902 2.93379 10.3741C2.93093 10.3628 2.92866 10.352 2.92668 10.3411C2.9239 10.3249 2.92154 10.3081 2.91985 10.2912C2.91839 10.2782 2.91752 10.2654 2.91703 10.2526C2.91691 10.2448 2.91675 10.2367 2.91675 10.2285L2.91706 10.2043C2.91754 10.192 2.91838 10.1798 2.91958 10.1675L2.91675 10.2285C2.91675 10.1891 2.9204 10.1505 2.92739 10.1131C2.92901 10.1041 2.93094 10.095 2.93308 10.0858C2.93752 10.067 2.94265 10.0489 2.94855 10.0311C2.95146 10.0223 2.95483 10.0129 2.95844 10.0035C2.96575 9.98471 2.97369 9.96678 2.98242 9.94932C2.98648 9.94111 2.99102 9.93251 2.99578 9.924C3.00359 9.91012 3.01163 9.89693 3.02014 9.88407C3.02614 9.87497 3.03279 9.8655 3.03973 9.85617L3.04514 9.84897C3.06198 9.82697 3.08025 9.80612 3.09981 9.78657L3.10056 9.78599L8.14222 4.76515C8.3868 4.52158 8.78253 4.5224 9.0261 4.76698C9.24753 4.98933 9.26699 5.33659 9.08493 5.58089L9.02427 5.65086L5.05675 9.60301L16.0417 9.60351C16.3869 9.60351 16.6667 9.88333 16.6667 10.2285Z"
                  fill="black"
                  fill-opacity="0.6"
                />
              </svg>
            </div>
            <div
              className="d-flex align-items-center chat-name cursor-pointer"
              onClick={() => navigate(`../${userName}`)}
            >
              <figure className="mb-0">
                <img
                  className="img-profile rounded-circle"
                  src={pic || profile}
                />
              </figure>
              <div>
                <p className="profile-name mb-0">
                  <b>{userName || "User"}</b>
                </p>
                {/* <p className="mt-1 chat-p">Active</p> */}
              </div>
            </div>
          </div>

          <div className="">
            <button className="btn btn-outline-secondary chat-btn">
              {name} Service
            </button>
          </div>
        </div>

        <div className="mt-3 chatbox-wrapper">
          {chats.map((item) => {
            return (
              <div className="row">
                <div
                  className={`d-flex justify-content-end align-items-center w-100 ${
                    item.user_id === userId ? "ml-auto" : ""
                  }`}
                >
                  <p
                    className={item.user_id === userId ? "sender" : "chat-box"}
                  >
                    {item?.text || item?.message}
                  </p>
                  <p className="chat-time">
                    {item?.created_at
                      ? formatOldTime(item?.created_at)
                      : formatTime(item?.now)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <form className="row" onSubmit={sendMessage}>
          <div className="d-flex justify-content-between align-items-center w-100">
            <input
              type="text"
              className="text-box border-0 form-control w-80"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type here"
            />
            <button
              className="btn p-0 cursor-pointer w-20"
              type="submit"
              disabled={message === ""}
            >
              <img src={sendBtn} className="img-fluid send-icon" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Chat;
